import { helpers } from "vuelidate/lib/validators";

const imagePreview = function () {
    return !this.hasImagePreviewError;
}

const imageSize = function () {
    return !this.imageFile || (this.imageFile && this.imageFile.size <= 2097152);
};

const imageType = function () {
    return (
        !this.imageFile ||
        (this.imageFile && /\.(gif|jpe?g|png)$/i.test(this.imageFile.name))
    );
};

const imageUrl = function (value) {
    let notRequiredAndEmpty = !helpers.req(value);
    let isModIsEditingByMod = this.isMod && this.isEditing && this.byMod;
    let validUrl = value.toLowerCase().startsWith("http");
    return notRequiredAndEmpty || isModIsEditingByMod || validUrl;
};

const postContent = function (value) {
    const hasMessage = value.length > 0 && value !== "<p><br></p>";
    const hasText = !!this.$refs.editor && this.$refs.editor.getText().trim().length > 0;
    const hasImage = this.imageData.length > 0 || this.imageUrl.length > 0;
    return (hasMessage || hasText) || hasImage;
};

export { imagePreview, imageSize, imageType, imageUrl, postContent };
